var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgChatBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 33.75H7.5C5.43188 33.75 3.75 32.0681 3.75 30V15C3.75 12.9319 5.43188 11.25 7.5 11.25H30C32.0681 11.25 33.75 12.9319 33.75 15V30C33.75 32.0681 32.0681 33.75 30 33.75H20.8144L11.25 41.4019V33.75ZM10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18H28C28.5523 18 29 17.5523 29 17C29 16.4477 28.5523 16 28 16H10ZM9 22C9 21.4477 9.44772 21 10 21H28C28.5523 21 29 21.4477 29 22C29 22.5523 28.5523 23 28 23H10C9.44772 23 9 22.5523 9 22ZM10 26C9.44772 26 9 26.4477 9 27C9 27.5523 9.44772 28 10 28H28C28.5523 28 29 27.5523 29 27C29 26.4477 28.5523 26 28 26H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 3.75H15C12.9319 3.75 11.25 5.43187 11.25 7.5H33.75C35.8181 7.5 37.5 9.18187 37.5 11.25V26.25C39.5681 26.25 41.25 24.5681 41.25 22.5V7.5C41.25 5.43187 39.5681 3.75 37.5 3.75Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBox);
export default __webpack_public_path__ + "static/media/chat-box.3b1aeaba99513d151741f049f3de6e55.svg";
export { ForwardRef as ReactComponent };